module.exports = __webpack_public_path__ + "static/media/Fearow_gaussian2.ca2a9950.png";